import { Controller, type FieldPath, type FieldValues, useFormContext } from 'react-hook-form';
import CheckboxGroup, { type CheckboxGroupProps } from '../../../Form/CheckboxGroup';
import type { HookInputBaseProps } from '../../types';

export interface HookCheckboxGroupPropsGroup<T extends FieldValues = FieldValues> extends CheckboxGroupProps, HookInputBaseProps<T> {
  name: FieldPath<T>;
}

export const HookCheckboxGroup = <T extends FieldValues>(props: HookCheckboxGroupPropsGroup<T>) => {
  const { name, required, validate, id, formMethods, ...rest } = props;
  const { control } = useFormContext<T>();
  const idOrName = id || name;

  return (
    <Controller
      name={name}
      rules={{ required: required && 'Required', validate }}
      control={formMethods?.control || control}
      render={({ field, fieldState: { error, isTouched } }) => {
        return <CheckboxGroup {...rest} {...field} id={idOrName} checked={field.value} error={error?.message} value={field?.value || []} />;
      }}
    />
  );
};
